import {Component, Type} from '@angular/core';
import {IGetClass, IModalWindow, ISetOptions} from 'src/app/utils/interfaces/modal-dialog.interface';
import {ModalWindowsTypes, TabNames} from 'src/app/core/enums';
import { SettingsViewComponent } from './settings-view/settings-view.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
    selector: 'asg-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: true,
    imports: [SidebarComponent, SettingsViewComponent]
})
export class SettingsComponent implements IModalWindow, ISetOptions, IGetClass {
  messageKey: TabNames;

  getWindowType(): Type<IModalWindow> {
    return SettingsComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.SETTINGS_WINDOW;
  }

  getInstanceOf(type: string): IModalWindow | IGetClass | ISetOptions | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'IGetClass':
        return this as unknown as IGetClass;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      default: return null;
    }
  }

  setOptions(options: any): void {
    options = options || {};
    this.messageKey = options.messageKey;
  }

  getClass(): string {
    return 'settings-modal';
  }
}
